<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import { Alert, AlertDescription } from 'next/polaris/ui/alert';

defineProps({
  color: {
    type: String,
    default: 'slate',
    validator: value =>
      ['blue', 'ruby', 'amber', 'slate', 'teal'].includes(value),
  },
  actionLabel: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['action']);

const triggerAction = () => {
  emit('action');
};
</script>

<template>
  <Alert
    :variant="color === 'ruby' ? 'destructive' : 'default'"
    :role="color === 'ruby' ? 'alert' : 'status'"
    class="flex items-center justify-between gap-2"
  >
    <AlertDescription class="min-w-0"><slot /></AlertDescription>
    <Button
      v-if="actionLabel"
      size="sm"
      variant="outline"
      :color="color === 'ruby' ? 'ruby' : 'slate'"
      :label="actionLabel"
      class="shrink-0"
      @click="triggerAction"
    />
  </Alert>
</template>
